<template>
  <div class="px-sm-4">
    <b-card body-class="p-md-1 p-0">
      <b-card-header class="align-items-start flex-sm-row flex-column-reverse">
        <b-card-title class="mt-sm-0 mt-2">
          <b-media class="align-items-center">
            <template #aside>
              <div
                v-if="avatarPreview || avatar"
                class="bg-dark d-flex justify-content-center align-items-center bg-secondary rounded-avatar"
                style="height: 100px"
              >
                <b-img
                  :src="avatarPreview || avatar || errorImage"
                  alt="avatar"
                  width="100px"
                  style="max-height: 100px"
                  class="p-25 rounded-avatar"
                  @error="setAltImg"
                />
              </div>
              <b-avatar
                alt="avatar"
                size="100px"
                class="bg-secondary text-muted rounded-avatar"
                v-else
              >
              </b-avatar>
            </template>
            <h5 class="mb-1 text-white">
              {{
                $route.params.id
                  ? "Edit user"
                  : $route.name == "users-edit-profile"
                  ? "Edit profile"
                  : "Create user"
              }}
            </h5>
            <div class="d-flex flex-wrap">
              <b-button
                class="gradient-btn ml-50 px-75"
                @click="$refs.previewavatar.click()"
              >
                <input
                  @input="changeAvatar"
                  ref="previewavatar"
                  type="file"
                  class="d-none"
                  accept="image/*"
                />
                <span class="d-none d-sm-inline">Upload</span>
                <feather-icon icon="EditIcon" class="d-inline d-sm-none" />
              </b-button>
              <b-button
                class="ml-50 px-75"
                @click="removeAvatar"
                :disabled="!avatar"
              >
                <feather-icon icon="TrashIcon" />
              </b-button>
            </div>
          </b-media>
        </b-card-title>

        <b-link
          :to="{
            name:
              $route.name == 'users-edit-profile' ? 'user-dashboard' : 'users',
          }"
        >
          <span v-if="$route.name == 'users-edit-profile'">
            back to the dashboard</span
          >
          <span v-else>back to the user list</span>
          <feather-icon icon="ChevronRightIcon"
        /></b-link>
      </b-card-header>
      <b-card-body>
        <validation-observer ref="createForm">
          <b-form class="form mt-2" @submit.prevent="createForm">
            <b-row>
              <b-col class="d-flex" lg="4" v-if="userData.type == 'admin'">
                <b-form-group
                  label-for="user_name"
                  class="w-100"
                  label="username"
                >
                  <validation-provider #default="{ errors }" name="username">
                    <b-form-input
                      :disabled="
                        $route.name == 'users-edit-profile' &&
                        userData.type !== 'admin'
                      "
                      id="user_name"
                      v-model="user_name"
                      name="user_name"
                      placeholder="Johon"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col class="d-flex" lg="4">
                <b-form-group
                  label-for="first-name"
                  class="w-100"
                  label="First name"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="First name"
                    rules="required"
                  >
                    <b-form-input
                      id="First-name"
                      v-model="first_name"
                      name="first-name"
                      placeholder="Johon"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col class="d-flex" lg="4">
                <b-form-group
                  label-for="last-name"
                  class="w-100"
                  label="Last name"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Last name"
                    rules="required"
                  >
                    <b-form-input
                      id="last-name"
                      v-model="last_name"
                      name="last-name"
                      placeholder="Doe"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col class="d-flex" lg="4">
                <b-form-group label-for="gender" class="w-100" label="Gender">
                  <b-button-group class="mb-md-1 mt-50">
                    <b-button
                      :variant="
                        gender == 'UNKNOWN' ? 'warning' : 'outline-warning'
                      "
                      @click="gender = 'UNKNOWN'"
                      style="
                        border-top-left-radius: 20px;
                        border-bottom-left-radius: 20px;
                      "
                      class="px-75"
                    >
                      Unknown
                    </b-button>
                    <b-button
                      :variant="
                        gender == 'MALE' ? 'warning' : 'outline-warning'
                      "
                      @click="gender = 'MALE'"
                      class="mx-1 px-75"
                    >
                      Male
                    </b-button>
                    <b-button
                      :variant="
                        gender == 'FEMALE' ? 'warning' : 'outline-warning'
                      "
                      @click="gender = 'FEMALE'"
                      style="
                        border-top-right-radius: 20px;
                        border-bottom-right-radius: 20px;
                      "
                      class="px-75"
                    >
                      Female
                    </b-button>
                  </b-button-group>
                </b-form-group>
              </b-col>
              <b-col class="d-flex" lg="4">
                <b-form-group
                  label-for="nationality"
                  class="w-100"
                  label="nationality"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Nationality"
                    rules="required"
                  >
                    <b-skeleton height="20px" v-if="loading" />
                    <select-box
                      v-else
                      v-model="nationality"
                      label="text"
                      class="w-100"
                      select="id"
                      searchable
                      url="country"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col class="d-flex align-items-center flex-wrap" lg="4">
                <b-form-group label-for="email" class="w-100" label="Email">
                  <validation-provider
                    #default="{ errors }"
                    name="Email"
                    rules="required|email"
                  >
                    <b-form-input
                      id="email"
                      v-model="email"
                      name="email"
                      :disabled="
                        ($route.params.id ||
                          $route.name == 'users-edit-profile') &&
                        mode == 'show'
                      "
                      placeholder="johndoe@example.com"
                      :state="errors.length > 0 ? false : null"
                      :autofocus="mode == 'edit'"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <div
                  v-if="userData.type == 'admin' && $route.params.id"
                  class="w-100 mb-1"
                >
                  <b-button
                    size="sm"
                    variant="outline-primary"
                    @click="mode = 'edit'"
                    v-if="mode == 'show'"
                    >Edit</b-button
                  >
                  <template v-else>
                    <b-button size="sm" @click="mode = 'show'"> Back </b-button>
                    <b-button
                      size="sm"
                      class="ml-50"
                      variant="outline-primary "
                      @click="changeEmail"
                    >
                      Change email
                    </b-button>
                  </template>
                </div>
                <div
                  v-if="$route.name == 'users-edit-profile'"
                  class="w-100 mb-1"
                >
                  <b-button
                    size="sm"
                    variant="outline-primary"
                    @click="showEditEmail = true"
                    >Edit</b-button
                  >
                </div>
              </b-col>
              <template v-if="$route.name == 'users-create'">
                <b-col class="d-flex" lg="4">
                  <b-form-group
                    label="Password"
                    class="w-100"
                    label-for="reset-password-new"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Password"
                      vid="Password"
                      rules="required|min:8|password"
                    >
                      <b-input-group
                        class="input-group-merge"
                        :class="errors.length > 0 ? 'is-invalid' : null"
                      >
                        <b-form-input
                          id="reset-password-new"
                          v-model="password"
                          :type="password1FieldType"
                          :state="errors.length > 0 ? false : null"
                          class="form-control-merge"
                          name="reset-password-new"
                          placeholder="············"
                          autocomplete="on"
                        />
                        <b-input-group-append is-text>
                          <feather-icon
                            class="cursor-pointer"
                            :icon="password1ToggleIcon"
                            @click="togglePassword1Visibility"
                          />
                        </b-input-group-append>
                      </b-input-group>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col class="d-flex" lg="4">
                  <b-form-group
                    label-for="reset-password-confirm"
                    label="Confirm Password"
                    class="w-100"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Confirm Password"
                      :rules="`required|min:8|confirmed:${password}`"
                    >
                      <b-input-group
                        class="input-group-merge"
                        :class="errors.length > 0 ? 'is-invalid' : null"
                      >
                        <b-form-input
                          id="reset-password-confirm"
                          v-model="password_confirmation"
                          :type="password2FieldType"
                          class="form-control-merge"
                          :state="errors.length > 0 ? false : null"
                          name="reset-password-confirm"
                          placeholder="············"
                          autocomplete="on"
                        />
                        <b-input-group-append is-text>
                          <feather-icon
                            class="cursor-pointer"
                            :icon="password2ToggleIcon"
                            @click="togglePassword2Visibility"
                          />
                        </b-input-group-append>
                      </b-input-group>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </template>
            </b-row>
            <div
              class="d-flex align-items-center flex-wrap justify-content-end"
            >
              <b-button class="mt-sm-0 mt-50 mr-50 gradient-btn" type="submit">
                submit
              </b-button>
              <b-button
                v-if="$route.params.id || $route.name == 'users-edit-profile'"
                variant="info"
                class="mt-sm-0 mt-50"
                @click="showChangePassword = true"
                >Change password</b-button
              >
            </div>
          </b-form>
        </validation-observer>
      </b-card-body>
    </b-card>
    <loader :loading="loading" />
    <b-modal v-model="showChangePassword" centered hide-footer>
      <change-password @closeShowChangePassword="showChangePassword = false" />
    </b-modal>
    <b-modal v-model="showEditEmail" centered hide-footer>
      <change-email @emailChanged="emailChanged" />
    </b-modal>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BButton,
  BForm,
  BFormInput,
  BFormGroup,
  BLink,
  BInputGroup,
  BInputGroupAppend,
  BFormCheckbox,
  BFormTextarea,
  BMedia,
  BAvatar,
  BImg,
  BModal,
  BButtonGroup,
  BSkeleton,
} from "bootstrap-vue";
import { required, email, phone, url } from "@validations";
import SelectBox from "@core/components/select-box/SelectBox.vue";
import Loader from "@/@core/components/loader/Loader.vue";
import ChangePassword from "./ChangePassword.vue";
import ChangeEmail from "./ChangeEmail.vue";

import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BSkeleton,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BLink,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    Loader,
    SelectBox,
    BFormTextarea,
    BMedia,
    BAvatar,
    BImg,
    BModal,
    ChangePassword,
    BButtonGroup,
    ChangeEmail,
  },
  data() {
    return {
      showChangePassword: false,
      first_name: "",
      last_name: "",
      email: "",
      password_confirmation: "",
      password: "",
      avatar: "",
      avatarPreview: "",
      loading: false,
      user_name: "",
      mode: "show",
      gender: "UNKNOWN",
      nationality: "",
      showEditEmail: false,
      userData: JSON.parse(localStorage.getItem("userData")),
      // validation rules
      required,
      email,
      phone,
      url,
      // Toggle Password
      password1FieldType: "password",
      password2FieldType: "password",
    };
  },
  // created() {
  //   if (this.$route.params.id || this.$route.name == "users-edit-profile") {
  //     this.getUser();
  //   }
  // },
  watch: {
    $route: {
      handler(val) {
        if (val.params.id || val.name == "users-edit-profile") {
          this.getUser();
        }
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    password1ToggleIcon() {
      return this.password1FieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    password2ToggleIcon() {
      return this.password2FieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
  },
  methods: {
    emailChanged() {
      this.getUser();
      this.showEditEmail = false;
    },
    togglePassword1Visibility() {
      this.password1FieldType =
        this.password1FieldType === "password" ? "text" : "password";
    },
    togglePassword2Visibility() {
      this.password2FieldType =
        this.password2FieldType === "password" ? "text" : "password";
    },
    async removeAvatar() {
      this.loading = true;
      if (this.$route.params.id || this.$route.name == "users-edit-profile") {
        try {
          await this.$http.delete(
            this.$route.name == "users-edit-profile"
              ? `panel/profile/user/avatar`
              : `panel/users/${this.$route.params.id}/avatar`
          );
          await this.getUser();
        } catch (err) {}
      } else {
        this.avatar = "";
        this.avatarPreview = "";
        this.$refs.previewavatar.value = "";
      }
      this.loading = false;
    },

    async changeAvatar(e) {
      this.loading = true;
      if (this.$route.params.id || this.$route.name == "users-edit-profile") {
        try {
          let formData = new FormData();
          formData.append("avatar", e.target.files[0]);
          const { data } = await this.$http.post(
            this.$route.name == "users-edit-profile"
              ? `panel/profile/user/avatar?_method=patch`
              : `panel/users/${this.$route.params.id}/avatar?_method=patch`,
            formData
          );
          this.$refs.previewavatar.value = "";
          await this.getUser();
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$route.params.id
                ? `User avatar updated`
                : `Profile avatar updated`,
              icon: "CoffeeIcon",
              variant: "success",
            },
          });
        } catch (err) {}
      } else {
        this.avatar = e.target.files[0];
        this.avatarPreview = URL.createObjectURL(this.avatar);
      }
      this.loading = false;
    },
    async getUser() {
      this.loading = true;
      try {
        const { data } = await this.$http.get(
          this.$route.name == "users-edit-profile"
            ? `/panel/profile/user`
            : `/panel/users/${this.$route.params.id}`
        );
        await Object.keys(
          this.$route.name == "users-edit-profile" ? data.user : data.data
        ).map((item) => {
          if (item == "socials") {
            Object.keys(this.socials).map((social) => {
              this.socials[social] =
                this.$route.name == "users-edit-profile"
                  ? data.data[0].socials[social]
                  : data.data.socials[social];
            });
          } else {
            this[item] =
              this.$route.name == "users-edit-profile"
                ? data.user[item]
                : data.data[item];
          }
        });
        if (this.$route.name == "users-edit-profile") {
          await localStorage.setItem(
            "userData",
            JSON.stringify({
              ...data.user,
              email_verified: data.user.email_verified_at ? true : false,
              type: data.abilities[0].includes("admin") ? "admin" : "user",
            })
          );
          await this.$store.dispatch("auth/setUserData", {
            ...data.user,
            email_verified: data.user.email_verified_at ? true : false,
            type: data.abilities[0].includes("admin") ? "admin" : "user",
          });
        }
      } catch (err) {}
      this.loading = false;
    },
    async changeEmail() {
      this.loading = true;
      try {
        const { data } = await this.$http.post(
          this.$route.name == "users-edit-profile"
            ? `/panel/profile/user/email?_method=patch`
            : `panel/users/${this.$route.params.id}/email?_method=patch`,

          { email: this.email.toLowerCase() }
        );
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$route.params.id
              ? `User email updated`
              : `Profile email updated`,
            icon: "CoffeeIcon",
            variant: "success",
          },
        });
      } catch (err) {}
      this.mode = "show";
      this.loading = false;
    },
    createForm() {
      this.$refs.createForm.validate().then(async (success) => {
        if (success) {
          this.loading = true;
          try {
            this.formData = await new FormData();
            let newObject = await {
              first_name: this.first_name,
              last_name: this.last_name,
              gender: this.gender,
              nationality_id: this.nationality,
              user_name: this.user_name,
            };
            (await !this.$route.params.id) && this.email
              ? (newObject.email = this.email.toLowerCase())
              : "";
            (await !this.$route.params.id) && this.avatar
              ? (newObject.avatar = this.avatar)
              : "";
            (await !this.$route.params.id) && this.password_confirmation
              ? (newObject.password_confirmation = this.password_confirmation)
              : "";
            (await !this.$route.params.id) && this.password
              ? (newObject.password = this.password)
              : "";
            await Object.keys(newObject).map((item, index) => {
              this.setFormData(newObject[item], index, item);
            });

            if (
              this.$route.params.id ||
              this.$route.name == "users-edit-profile"
            ) {
              const { data } = await this.$http.post(
                this.$route.name == "users-edit-profile"
                  ? `panel/profile/user?_method=put`
                  : `panel/users/${this.$route.params.id}?_method=put`,
                this.formData
              );
              await this.getUser();
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: this.$route.params.id
                    ? `User updated`
                    : `Profile updated`,
                  icon: "CoffeeIcon",
                  variant: "success",
                },
              });
            } else {
              const { data } = await this.$http.post(
                "panel/users",
                this.formData
              );
              this.$router.push({ name: "users" });
            }
          } catch (err) {}
          this.loading = false;
        }
      });
    },
  },
};
</script>

<style></style>
